import React, { useContext, useEffect, useLayoutEffect, useState, useRef } from 'react'

import logo from "../images/LearnHubLogo.png"
import Notification from './Notification'
import baseUrl from '../api/utils'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'
import errorimg from "../images/errorimg.png"
import undraw_profile from "../images/profile-white.png";
import { GlobalStateContext } from "../Context/GlobalStateProvider";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import UpgradePlansModal from "../AuthenticationPages/UpgradePlansModal"; // adjust the path if your folder is different

const Header = ({ searchQuery, handleSearchChange }) => {

  const navigate = useNavigate();
  const { siteSettings, lowStockItems, setLowStockItems } = useContext(GlobalStateContext);
  const islogedin = sessionStorage.getItem("token") !== null;
  const location = useLocation();
  const [data, setdata] = useState({ name: "", profileImage: null });
  const [count, setcount] = useState(0);
  const [profileOpen, setProfileOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const { itemSettings } = useContext(GlobalStateContext);
  const [licenseInfo, setLicenseInfo] = useState(null);

  // ── Dark / Light mode (remembered after refresh) ──
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  // ── Free trial usage (undefined = still loading, null = failed / not available) ──
  const [freeUsage, setFreeUsage] = useState(undefined);
  const [showUpgrade, setShowUpgrade] = useState(false);

  // ── Banner carousel state ──
  const [bannerIndex, setBannerIndex] = useState(0);
  const bannerTimerRef = useRef(null);

  // ── Logo width measurement ──
  const mHeaderRef = useRef(null);
  const [logoOffset, setLogoOffset] = useState(0);

  useLayoutEffect(() => {
    const el = mHeaderRef.current;
    if (!el) return;
    const measure = () => setLogoOffset(el.getBoundingClientRect().width);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("role");

  useEffect(() => {
    const cachedData = sessionStorage.getItem("profileData");
    if (cachedData) {
      setdata(JSON.parse(cachedData));
    } else {
      const fetchItems = async () => {
        try {
          if (token) {
            const response = await axios.get(`${baseUrl}/Edit/profiledetails`, {
              headers: { Authorization: token },
            });
            if (response.status === 200) {
              const fetchedData = response.data;
              setdata(fetchedData);
              sessionStorage.setItem("profileData", JSON.stringify(fetchedData));
            }
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchItems();
    }
  }, []);

  const fetchUnreadCount = async () => {
    try {
      if (role !== "SYSADMIN" && token) {
        const response = await axios.get(`${baseUrl}/unreadCount`, {
          headers: { Authorization: token },
        });
        if (response.status === 200) {
          setcount(response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  };

  const fetchLowStock = async () => {
    try {
      if (token && role !== "SYSADMIN") {
        const res = await axios.get(`${baseUrl}/getLowStockItems`, {
          headers: { Authorization: token }
        });
        console.log("Low stock items:", res.data);
        setLowStockItems(res.data);
      } else {
        console.log("Token:", token, "Role:", role);
      }
    } catch (err) {
      console.error("Low stock fetch failed", err);
    }
  };

  const fetchLicenseInfo = async () => {
    try {
      if (token && role !== "SYSADMIN") {
        const res = await axios.get(`${baseUrl}/api/v2/license/notification`, {
          headers: { Authorization: token },
        });
        setLicenseInfo(res.data);
      }
    } catch (err) {
      console.error("License info fetch failed", err);
    }
  };

  const fetchFreeUsage = async () => {
    try {
      if (token && role !== "SYSADMIN") {
        const res = await axios.get(`${baseUrl}/api/v2/license/free-usage`, {
          headers: { Authorization: token },
        });
        setFreeUsage(res.data);
      }
    } catch (err) {
      setFreeUsage(null);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  useEffect(() => {
    fetchLowStock();
  }, []);

  useEffect(() => {
    fetchLicenseInfo();
  }, []);

  // The header stays mounted on every page, so refresh the free-trial numbers on each page change
  useEffect(() => {
    fetchFreeUsage();
  }, [location.pathname]);

  const handlemarkallasRead = async (notificationIds) => {
    try {
      const markread = await axios.post(`${baseUrl}/MarkAllASRead`, notificationIds, {
        headers: { Authorization: token },
      });
      if (markread.status === 200) {
        fetchUnreadCount();
      }
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  };

  const MySwal = withReactContent(Swal);
  const imageSource = data.profileImage
    ? `data:image/jpeg;base64,${data.profileImage}`
    : undraw_profile;

  const handleLogout = async () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!token) return;
        try {
          const response = await axios.post(`${baseUrl}/logoutuser`, {}, {
            headers: { Authorization: token },
          });
          if (response.status === 200) {
            sessionStorage.clear();
            // keep the chosen theme after logout
            const savedTheme = localStorage.getItem("theme");
            localStorage.clear();
            if (savedTheme) localStorage.setItem("theme", savedTheme);
            navigate("/login");
          }
        } catch (error) {
          MySwal.fire({
            title: "Error!",
            text: "An error occurred while logging out. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".hdr-notif-wrapper")) {
        setNotifOpen(false);
      }
      if (!e.target.closest(".hdr-profile-wrapper")) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayName = data.name
    ? (data.name.length > 15 ? data.name.substring(0, 15) + "…" : data.name)
    : "Admin";
  const firstLetter = displayName.charAt(0).toUpperCase();

  // ── License badge styling logic ──
  const getLicenseBadgeColors = () => {
    if (!licenseInfo) return { bg: "rgba(255,255,255,0.04)", color: "#bbb", border: "rgba(255,255,255,0.08)" };
    if (licenseInfo.isExpired)
      return { bg: "rgba(220,53,69,0.15)", color: "#ff4d5e", border: "rgba(220,53,69,0.5)" };
    if (licenseInfo.daysLeft !== null && licenseInfo.daysLeft !== undefined && licenseInfo.daysLeft <= 5)
      return { bg: "rgba(220,53,69,0.15)", color: "#ff4d5e", border: "rgba(220,53,69,0.5)" };
    if (licenseInfo.shouldWarn)
      return { bg: "rgba(255,165,0,0.05)", color: "#f0cf9a", border: "rgba(255,165,0,0.15)" };
    return { bg: "rgba(40,167,69,0.15)", color: "#2ecc59", border: "rgba(40,167,69,0.5)" };
  };

  const licenseColors = getLicenseBadgeColors();
  const isCritical = licenseInfo && !licenseInfo.isExpired && licenseInfo.daysLeft !== null && licenseInfo.daysLeft !== undefined && licenseInfo.daysLeft <= 5;

  const getLicenseExpiryDateText = () => {
    if (!licenseInfo) return "";
    const raw = licenseInfo.expiryDate || licenseInfo.expiresOn || licenseInfo.validUntil;
    let dateObj = null;
    if (raw) {
      dateObj = new Date(raw);
    } else if (licenseInfo.daysLeft !== null && licenseInfo.daysLeft !== undefined) {
      dateObj = new Date();
      dateObj.setDate(dateObj.getDate() + licenseInfo.daysLeft);
    }
    if (!dateObj || isNaN(dateObj.getTime())) return "";
    return dateObj.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  const licenseExpiryDateText = getLicenseExpiryDateText();

  // ── Inline SVG icons ──
  const ShieldIcon = ({ color }) => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l8 3v6c0 5-3.4 9-8 11-4.6-2-8-6-8-11V5l8-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
  const AlertTriangleIcon = ({ color }) => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
  const AlertCircleIcon = ({ color }) => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );

  // ── Dismissed-banner tracking ──
  const [dismissedMap, setDismissedMap] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("hdr_banner_dismissed") || "{}");
    } catch {
      return {};
    }
  });

  const handleDismissBanner = (item) => {
    const next = { ...dismissedMap, [item.key]: item.label };
    setDismissedMap(next);
    try {
      sessionStorage.setItem("hdr_banner_dismissed", JSON.stringify(next));
    } catch {
      // sessionStorage unavailable — dismissal just won't persist past this render
    }
  };

  // ── Build the list of banner slides ──
  const rawBannerItems = [];

    // ── Free plan slide (FREE licenses only) — limits are per financial year ──
  if (role !== "SYSADMIN" && freeUsage && freeUsage.isFree) {
    const invoices = Number(freeUsage.invoices || 0);
    const maxInvoices = Number(freeUsage.maxInvoices || 100);
    const sales = Number(freeUsage.sales || 0);
    const maxSales = Number(freeUsage.maxSales || 1200000);

    const worstPct = Math.max(
      (invoices / maxInvoices) * 100,
      (sales / maxSales) * 100
    );
    const fEnded = !!freeUsage.freeLimitReached;
    const fNear = !fEnded && worstPct >= 80;

    const green  = { bg: "rgba(40,167,69,0.15)", color: "#2ecc59", border: "rgba(40,167,69,0.5)" };
    const orange = { bg: "rgba(255,165,0,0.15)", color: "#ffb84d", border: "rgba(255,165,0,0.5)" };
    const red    = { bg: "rgba(220,53,69,0.15)", color: "#ff4d5e", border: "rgba(220,53,69,0.5)" };

    const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
    const maxSalesText = `₹${maxSales / 100000} lakh`;

    const fyText = freeUsage.financialYear ? `FY ${freeUsage.financialYear}` : "this year";
    const resetDateObj = freeUsage.resetDate ? new Date(`${freeUsage.resetDate}T00:00:00`) : null;
    const resetText =
      resetDateObj && !isNaN(resetDateObj.getTime())
        ? resetDateObj.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
        : "1 April";

    rawBannerItems.push({
      key: "freetrial",
      Icon: fEnded || fNear ? AlertTriangleIcon : ShieldIcon,
      colors: fEnded ? red : fNear ? orange : green,
      critical: fEnded,
      label: fEnded
        ? "Free limit reached"
        : fNear
        ? "Free plan: almost at limit"
        : `Free plan: ${fyText}`,
      description: fEnded
        ? role === "ADMIN"
          ? `View only. Upgrade to continue, or wait until ${resetText} for the limit to reset.`
          : `View only. Please contact your Admin to upgrade. Limit resets on ${resetText}.`
        : "",
      stats: fEnded
        ? null
        : [
            {
              label: "Invoices",
              value: `${invoices} / ${maxInvoices}`,
              pct: (invoices / maxInvoices) * 100,
            },
            {
              label: "Sales",
              value: `${inr(sales)} / ${maxSalesText}`,
              pct: (sales / maxSales) * 100,
            },
          ],
      onClick: null,
    });
  }

  // ── License slide: paid licenses only, and only in the last 30 days (or expired) ──
  const licenseReminderDue =
    licenseInfo &&
    (licenseInfo.isExpired ||
      (licenseInfo.daysLeft !== null &&
        licenseInfo.daysLeft !== undefined &&
        licenseInfo.daysLeft <= 30));

  if (
    role !== "SYSADMIN" &&
    licenseReminderDue &&
    freeUsage !== undefined &&
    !(freeUsage && freeUsage.isFree)
  ) {
    rawBannerItems.push({
      key: "license",
      Icon: licenseInfo.isExpired || isCritical ? AlertTriangleIcon : ShieldIcon,
      colors: licenseColors,
      critical: !!(licenseInfo.isExpired || isCritical),
      label: licenseInfo.isExpired
        ? "License expired"
        : `License: ${licenseInfo.daysLeft} day${licenseInfo.daysLeft === 1 ? "" : "s"} left`,
      description: licenseExpiryDateText
        ? `Your license will expire on ${licenseExpiryDateText}. Please renew to continue using all features.`
        : "Please renew your license to continue using all features.",
      onClick: () => navigate("/license/upload"),
    });
  }

  if (role !== "SYSADMIN" && itemSettings.showLowStockDialog && lowStockItems.length > 0) {
    rawBannerItems.push({
      key: "lowstock",
      Icon: AlertCircleIcon,
      colors: { bg: "rgba(255,165,0,0.08)", color: "#f0cf9a", border: "rgba(255,165,0,0.25)" },
      label: `Low stock: ${lowStockItems.length} item${lowStockItems.length === 1 ? "" : "s"}`,
      description: "Some items are running low. Review and restock soon.",
      onClick: () => setNotifOpen(true),
    });
  }

  const bannerItems = rawBannerItems.filter((item) => dismissedMap[item.key] !== item.label);

  useEffect(() => {
    if (bannerIndex >= bannerItems.length && bannerItems.length > 0) {
      setBannerIndex(0);
    }
  }, [bannerItems.length, bannerIndex]);

  useEffect(() => {
    if (bannerTimerRef.current) clearInterval(bannerTimerRef.current);
    if (bannerItems.length > 1) {
      bannerTimerRef.current = setInterval(() => {
        setBannerIndex((i) => (i + 1) % bannerItems.length);
      }, 5000);
    }
    return () => {
      if (bannerTimerRef.current) clearInterval(bannerTimerRef.current);
    };
  }, [bannerItems.length]);

  const handleBannerNext = () => {
    if (bannerItems.length === 0) return;
    setBannerIndex((i) => (i + 1) % bannerItems.length);
    if (bannerTimerRef.current) clearInterval(bannerTimerRef.current);
    if (bannerItems.length > 1) {
      bannerTimerRef.current = setInterval(() => {
        setBannerIndex((i) => (i + 1) % bannerItems.length);
      }, 5000);
    }
  };

  const activeBanner = bannerItems[bannerIndex] || null;
  const bannerClickable = !!(activeBanner && activeBanner.onClick);

  return (
    <header className="navbar pcoded-header navbar-expand-lg navbar-light header-blue">

      <style>{`
        .hdr-banner {
          transition: filter 0.15s ease;
        }
        .hdr-banner--clickable:hover {
          filter: brightness(1.1);
        }
        .hdr-banner-label {
          flex-shrink: 0;
        }
        .hdr-banner-desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          opacity: 0.85;
        }
        .hdr-banner-arrow {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: rgba(255,255,255,0.08);
          cursor: pointer;
          transition: background 0.15s ease;
        }
        .hdr-banner-arrow:hover {
          background: rgba(255,255,255,0.18);
        }
        .hdr-banner-close {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: rgba(255,255,255,0.06);
          cursor: pointer;
          opacity: 0.7;
          transition: background 0.15s ease, opacity 0.15s ease;
        }
        .hdr-banner-close:hover {
          background: rgba(255,255,255,0.18);
          opacity: 1;
        }
        .hdr-banner-dots {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          flex-shrink: 0;
        }
        .hdr-banner-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.25);
          cursor: pointer;
          transition: background 0.15s ease, transform 0.15s ease;
        }
        .hdr-banner-dot--active {
          background: #2ecc59;
          transform: scale(1.2);
        }
        @keyframes hdr-critical-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(220,53,69,0.18); }
          50%      { box-shadow: 0 0 0 4px rgba(220,53,69,0); }
        }
        .hdr-banner--critical {
          animation: hdr-critical-pulse 2.4s ease-in-out infinite;
        }
        .hdr-upgrade-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          height: 34px;
          padding: 0 14px;
          border: none;
          border-radius: 17px;
          background: linear-gradient(90deg, #f5a623, #f76b1c);
          color: #fff;
          font-size: 0.8rem;
          font-weight: 700;
          white-space: nowrap;
          cursor: pointer;
          transition: filter 0.15s ease, transform 0.15s ease;
        }
        .hdr-upgrade-btn:hover {
          filter: brightness(1.1);
          transform: translateY(-1px);
        }
        .hdr-upgrade-btn--urgent {
          background: linear-gradient(90deg, #dc3545, #ff6b6b);
          animation: hdr-critical-pulse 2.4s ease-in-out infinite;
        }
        @media (max-width: 640px) {
          .hdr-upgrade-text { display: none; }
          .hdr-upgrade-btn { padding: 0 10px; }
        }

        /* ── Free trial usage stats (Invoices / Sales) ── */
        .hdr-banner-stats {
          display: flex;
          align-items: center;
          gap: 22px;
          margin-right: 40px;
          min-width: 0;
          flex: 1 1 auto;
          overflow: hidden;
        }
        .hdr-stat {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          width: 180px;
          flex: 0 0 180px;
        }
        .hdr-stat-top {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 8px;
          line-height: 1;
        }
        .hdr-stat-label {
          font-size: 0.62rem;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.55);
        }
        .hdr-stat-value {
          font-size: 0.74rem;
          font-weight: 600;
          color: #e6edf1;
          white-space: nowrap;
          font-variant-numeric: tabular-nums;
        }
        .hdr-stat-bar {
          height: 3px;
          border-radius: 2px;
          background: rgba(255,255,255,0.14);
          overflow: hidden;
        }
        .hdr-stat-fill {
          display: block;
          height: 100%;
          border-radius: 2px;
          transition: width 0.3s ease;
        }

        @media (max-width: 900px) {
          .hdr-banner-desc,
          .hdr-banner-stats {
            display: none;
          }
        }
        @media (max-width: 640px) {
          .hdr-banner {
            display: none !important;
          }
        }
      `}</style>

      <div className="m-header" ref={mHeaderRef}>
        {islogedin && (
          <a className="mobile-menu" id="mobile-collapse" href="#!">
            <span></span>
          </a>
        )}

        <a href="#" onClick={() => navigate("/admin/dashboard")} className="b-brand" >
          <img
            src={siteSettings.sitelogo
              ? `data:image/jpeg;base64,${siteSettings.sitelogo}`
              : logo}
            alt="logo"
            className="logo"
          />
        </a>
      </div>

           {/* keeps the banner clear of the logo while it sits on the right */}
      {islogedin && (
        <div style={{ flex: "0 0 auto", width: `${Math.max(logoOffset, 90) + 60}px` }} />
      )}

      {/* ── 📢 Notification Banner (free trial / license / low stock / etc.) ── */}
      {islogedin && activeBanner && (
        <div
          className={`hdr-banner ${bannerClickable ? "hdr-banner--clickable" : ""} ${activeBanner.critical ? "hdr-banner--critical" : ""}`}
          style={{
            display: "flex",
            alignItems: "center",
            alignSelf: "center",
            gap: "10px",
            flex: "0 1 auto",
            minWidth: 0,
            maxWidth: "1000px",
            marginLeft: "auto",
            marginRight: "-20px",
            height: "44px",
            padding: "0 8px 0 6px",
            borderRadius: "22px",
            background: "rgba(255,255,255,0.07)",
            border: `1px solid ${activeBanner.colors.border}`,
            boxSizing: "border-box",
            cursor: bannerClickable ? "pointer" : "default",
            position: "relative",
            zIndex: 1,
          }}
          onClick={bannerClickable ? activeBanner.onClick : undefined}
        >
         <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0, flex: "0 1 auto" }}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                background: activeBanner.colors.bg,
                flex: "0 0 24px",
              }}
            >
              <activeBanner.Icon color={activeBanner.colors.color} />
            </span>

            <span
              className="hdr-banner-label"
              style={{
                fontSize: "0.85rem",
                fontWeight: 700,
                color: activeBanner.colors.color,
                whiteSpace: "nowrap",
                flex: "0 0 auto",
              }}
            >
              {activeBanner.label}
            </span>

            <span style={{ color: "rgba(255,255,255,0.28)", flex: "0 0 auto" }}>|</span>

            {activeBanner.stats ? (
              <div className="hdr-banner-stats">
                {activeBanner.stats.map((s) => (
                  <div className="hdr-stat" key={s.label}>
                    <div className="hdr-stat-top">
                      <span className="hdr-stat-label">{s.label}</span>
                      <span className="hdr-stat-value">{s.value}</span>
                    </div>
                    <span className="hdr-stat-bar">
                      <span
                        className="hdr-stat-fill"
                        style={{
                          width: `${Math.min(100, s.pct > 0 ? Math.max(s.pct, 4) : 0)}%`,
                          background: activeBanner.colors.color,
                        }}
                      />
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <span
                className="hdr-banner-desc"
                style={{ fontSize: "0.8rem", color: "#d7dee3", minWidth: 0, flex: "1 1 auto" }}
              >
                {activeBanner.description}
              </span>
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: "0 0 auto" }}>
            {bannerItems.length > 1 && (
              <>
                <span
                  className="hdr-banner-arrow"
                  onClick={(e) => { e.stopPropagation(); handleBannerNext(); }}
                  title="Next"
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </span>

                <span className="hdr-banner-dots">
                  {bannerItems.map((item, i) => (
                    <span
                      key={item.key}
                      className={`hdr-banner-dot ${i === bannerIndex ? "hdr-banner-dot--active" : ""}`}
                      onClick={(e) => { e.stopPropagation(); setBannerIndex(i); }}
                    />
                  ))}
                </span>
              </>
            )}

            <span
              className="hdr-banner-close"
              onClick={(e) => { e.stopPropagation(); handleDismissBanner(activeBanner); }}
              title="Dismiss"
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </span>
          </div>
        </div>
      )}

           <div className={`d-flex align-items-center ${islogedin && activeBanner ? "" : "ml-auto"}`}>

        {islogedin && (
          <ul className="navbar-nav p-1 flex-row align-items-center">

            {/* ── ⭐ Upgrade Plan button (ADMIN on a FREE license only) ── */}
            {role === "ADMIN" && freeUsage && freeUsage.isFree && (
              <li className="mr-2">
                <button
                  className={`hdr-upgrade-btn ${freeUsage.freeLimitReached ? "hdr-upgrade-btn--urgent" : ""}`}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={() => setShowUpgrade(true)}
                  title="Upgrade to a paid plan"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="17 11 12 6 7 11" />
                    <polyline points="17 18 12 13 7 18" />
                  </svg>
                  <span className="hdr-upgrade-text">Upgrade Plan</span>
                </button>
              </li>
            )}

            {/* ── 🔔 Notification Bell ── */}
            {role !== "SYSADMIN" && (
              <li className="mr-2">
                <div className="hdr-notif-wrapper">
                  <button
                    className={`hdr-icon-btn ${notifOpen ? "active" : ""}`}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => {
                      setNotifOpen(!notifOpen);
                      setProfileOpen(false);
                      if (!notifOpen) fetchUnreadCount();
                      fetchLowStock();
                    }}
                  >
                    <i className="feather icon-bell"></i>

                    {itemSettings.showLowStockDialog && lowStockItems.length > 0
                      ? <span className="hdr-badge-warning" title="Low Stock Alert!">⚠️</span>
                      : count > 0 && <span className="hdr-badge">{count > 99 ? "99+" : count}</span>
                    }

                  </button>

                  {notifOpen && (
                    <div className="hdr-dropdown hdr-dropdown--notif">
                      <Notification handlemarkallasRead={handlemarkallasRead} />
                    </div>
                  )}
                </div>
              </li>
            )}

            {/* ── ☀️ Sun / Moon Theme Toggle ── */}
            <li className="mr-2">
              <button
                className="hdr-icon-btn"
                title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
                onClick={() => setDarkMode((prev) => !prev)}
              >
                {darkMode ? (
                  /* dark mode is ON -> show moon */
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="hdr-sun-svg"
                  >
                    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
                  </svg>
                ) : (
                  /* light mode -> show sun */
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="hdr-sun-svg"
                  >
                    <circle cx="12" cy="12" r="4" />
                    <line x1="12" y1="2"    x2="12" y2="4" />
                    <line x1="12" y1="20"   x2="12" y2="22" />
                    <line x1="4.22"  y1="4.22"  x2="5.64"  y2="5.64" />
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                    <line x1="2"  y1="12"   x2="4"  y2="12" />
                    <line x1="20" y1="12"   x2="22" y2="12" />
                    <line x1="4.22"  y1="19.78" x2="5.64"  y2="18.36" />
                    <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22" />
                  </svg>
                )}
              </button>
            </li>

            {/* ── 👤 Profile Pill ── */}
            <li>
              <div className="hdr-profile-wrapper">
                <div
                  className="hdr-profile-pill"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={() => { setProfileOpen(!profileOpen); setNotifOpen(false); }}
                >
                  {data.profileImage ? (
                    <img
                      src={imageSource}
                      onError={e => { e.target.src = errorimg; }}
                      alt="profile"
                      className="hdr-avatar-img"
                    />
                  ) : (
                    <div className="hdr-avatar-letter">{firstLetter}</div>
                  )}
                  <span className="hdr-profile-name">{displayName}</span>
                  <i className="feather icon-chevron-down hdr-profile-caret"></i>
                </div>

                {profileOpen && (
                  <div className="hdr-dropdown">
                    {role !== "SYSADMIN" && (
                      <a href="/course/dashboard/profile" className="hdr-dropdown-item">
                        <i className="feather icon-user"></i> Profile
                      </a>
                    )}
                    <button
                      onClick={handleLogout}
                      className="hdr-dropdown-item danger"
                    >
                      <i className="feather icon-log-out"></i> Logout
                    </button>
                  </div>
                )}
              </div>
            </li>

          </ul>
        )}

        {!islogedin && (
          <div className="ml-auto p-2" style={{ width: "250px", display: "flex", alignItems: "end", justifyContent: "flex-end" }}>
            <button className="btn btn-sm btn-success mr-2" onClick={() => navigate("/login")}>
              Sign In
            </button>
            <button className="btn btn-sm btn-secondary" onClick={() => navigate("/StudentRegistration")}>
              Sign Up
            </button>
          </div>
        )}

      </div>

      {/* Upgrade plans popup (opened ONLY by the "Upgrade Plan" button) */}
      <UpgradePlansModal show={showUpgrade} onClose={() => setShowUpgrade(false)} />
    </header>
  );
};

export default Header;